import { ReactElement } from 'react';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys, FiltersTranslationKeys } from 'intl/keys';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { ButtonContained, ButtonText } from 'components/general';
import {
  createPresetDialogActionsSx,
  createPresetDialogContentSx,
  createPresetDialogPaperSx,
  createPresetDialogTitleSx,
} from '../styles';

const PRESET_DIALOG_TITLE_KEY = {
  rename: FiltersTranslationKeys.renamePresetTitle,
  create: FiltersTranslationKeys.createPresetTitle,
} as const;

type CreatePresetDialogProps = {
  open: boolean;
  isRenameMode: boolean;
  presetName: string;
  onPresetNameChange: (value: string) => void;
  onClose: () => void;
  onSubmit: () => void;
};

export function CreatePresetDialog({
  open,
  isRenameMode,
  presetName,
  onPresetNameChange,
  onClose,
  onSubmit,
}: CreatePresetDialogProps): ReactElement {
  const intl = useIntl();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='sm'
      PaperProps={{ sx: createPresetDialogPaperSx }}
    >
      <DialogTitle sx={createPresetDialogTitleSx}>
        {formatTranslation(
          intl,
          PRESET_DIALOG_TITLE_KEY[isRenameMode ? 'rename' : 'create']
        )}
      </DialogTitle>
      <DialogContent sx={createPresetDialogContentSx}>
        <TextField
          autoFocus
          fullWidth
          margin='dense'
          label={formatTranslation(intl, FiltersTranslationKeys.presetNameLabel)}
          value={presetName}
          onChange={(event) => onPresetNameChange(event.target.value)}
        />
      </DialogContent>
      <DialogActions sx={createPresetDialogActionsSx}>
        <ButtonText onClick={onClose}>
          {formatTranslation(intl, CommonTranslationKeys.cancel)}
        </ButtonText>
        <ButtonContained onClick={onSubmit} disabled={!presetName.trim()}>
          {formatTranslation(intl, CommonTranslationKeys.save)}
        </ButtonContained>
      </DialogActions>
    </Dialog>
  );
}
